import React from 'react';
import classNames from 'classnames';

/**
 * Wrapper that combines the header Atlas component and tsk-canvas
 */
export const Page = React.forwardRef(function Page(
    props: {
        children: React.ReactNode;
        className?: string;
    },
    ref: React.ForwardedRef<HTMLDivElement>,
) {
    return (
        <div className={classNames('tsk-page', props.className)} ref={ref}>
            {props.children}
        </div>
    );
});

/**
 * @deprecated Use Page instead with Atlas components
 */
export const PageWrapper = React.forwardRef(function PageWrapper(
    {
        children,
    }: {
        children: React.ReactNode;
    },
    ref: React.Ref<HTMLDivElement>,
) {
    return (
        <div className={'page__container'} ref={ref}>
            {children}
        </div>
    );
});

/**
 * @deprecated Use Page instead with Atlas components
 */
export const PageHeaderTitle = ({ children }: { children: React.ReactNode }) => {
    return (
        <h1 className={'page__header-title'} data-testid="header-title">
            {children}
        </h1>
    );
};

/**
 * @deprecated Use Page instead with Atlas components
 */
export const PageHeaderActions = ({ children }: { children: React.ReactNode }) => {
    return <div className={'page__header-actions'}>{children}</div>;
};

/**
 * @deprecated Not needed when using Page instead with Atlas components
 */
export const PageContent = ({ children, className }: { children: React.ReactNode; className?: string }) => {
    return <div className={classNames(className, 'page__content')}>{children}</div>;
};
